import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-contact-ceo',
  templateUrl: './contact-ceo.component.html',
  styleUrls: ['./contact-ceo.component.scss']
})
export class ContactCeoComponent implements OnInit {

  fullname:string = "";
  isValidEmail:boolean = false;
  emaiID:string = "";
  isEmail:boolean = false;
  isMessage:boolean = false;
  message:string = "";
  public contactUsForm!:FormGroup


  constructor(private snackBar: MatSnackBar, private formBuilder: FormBuilder) {
    this.contactUsFormControls();
   }

  ngOnInit(): void {
  }

  contactUsFormControls(){
    this.contactUsForm = this.formBuilder.group({
      fullname:['', [Validators.required]],
      emaiID:['', [Validators.required, Validators.email]],
      message:  ['', [ Validators.required]]
    });
  }

  // Submiting the Contact Us form
  postContactUsInfo(){
    
  }

  openSnackBar(message:any, action = '',isError:boolean=false) {
    this.snackBar.open(message, action, {
    duration: 3000,
    // verticalPosition: 'top',
    // horizontalPosition:'right',
    panelClass: isError ? ['primary'] : ''
  });
  }

  alphabetsOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    return /^[a-zA-Z\s]+$/.test(String.fromCharCode(charCode));
  }
}
